<template>
    <div class="wrapper">
        <div class="container" :class="{ scrollable }" :style="background">
            <div
                class="inner"
                :class="{ popup }"
                :style="{ 'padding-top': spaceTop, 'align-items': align }"
            >
                <div
                    class="main-content"
                    :class="{ column, popup }"
                    :style="{ 'align-items': align, width: contentWidth }"
                >
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        popup: Boolean,
        showDescription: Boolean,
        description: String,
        question: String,
        column: Boolean,
        backgroundImage: String,
        backgroundColor: {
            type: String,
            default: '#ddd',
        },
        backgroundPosition: {
            type: String,
            default: 'top',
        },
        spaceTop: {
            type: String,
            default: '0',
        },
        align: {
            type: String,
            default: 'center',
        },
        contentWidth: {
            type: String,
            default: '100%',
        },
        scrollable: Boolean,
    },
    computed: {
        background() {
            if (this.backgroundImage) {
                return {
                    'background-image': `url(${this.backgroundImage})`,
                    'background-position': this.backgroundPosition,
                };
            }
            return {
                'background-color': this.backgroundColor,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    position: relative;
    margin: auto;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    .container {
        width: 100%;
        height: 100%;
        position: relative;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top;
        .inner {
            position: relative;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            &.popup {
                min-height: 100%;
                height: auto;
            }
        }
        .main-content {
            box-sizing: border-box;
            margin: auto;
            height: 100%;
            display: flex;
            &.column {
                flex-direction: column;
            }
            &.popup {
                flex: 1;
            }
        }
    }
    .scrollable {
        overflow: auto;
        &::-webkit-scrollbar {
            display: none;
        }
    }
    @media screen and (min-width: 375px) {
        min-width: 375px;
    }
}
</style>
